import { WordListItem } from '@kp/shared/components/word-cloud/word-list-item.model';
import { Deserializable } from '@ktypes/models';

export class GroupTraitItem extends WordListItem implements Deserializable<any, GroupTraitItem> {
  constructor(public name?: string, public count?: number) {
    super(name, count);
  }

  deserialize(input: any, existingData?: GroupTraitItem): GroupTraitItem {
    if (this == null) {
      return null;
    }
    this.name = input.name;
    this.word = input.name;
    this.count = input.count;
    this.size = input.count;
    return this;
  }
}
